const Constant = {
    //BASE_URL: 'http://localhost:8000/api/host'
     BASE_URL : 'https://www.dayfuna.thegotjob.com/api/host'
    //BASE_URL : 'https://www.api-dayfuna.mushroomworldbd.com/api/host'
 //   BASE_URL: 'http://192.168.0.101:8000/api/backend'
    //  BASE_URL: 'https://www.api.weblearnbd.com/api/backend'
}
export default Constant
